import { useRef, useEffect, useState, useCallback, useMemo } from 'react';
import { useApiConfigUsuarios } from '../../../api/api.ConfigUsuarios';
import DataGrid, { Button as Butt, Column, LoadPanel, Paging, SearchPanel, Editing, RequiredRule } from 'devextreme-react/data-grid';
import { Profile } from '../../../types/types.user';
import { ModalPermissionsModal } from './Modals/ModalPermisos';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

const Index = () => {
  const dataGridRef = useRef<DataGrid>(null);
  const [data, setData] = useState<Profile[]>([]);
  //const [permisos, setPermisos] = useState<Permissions[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [idPermiso, setIdPermiso] = useState<number>(0);
  const [perfil, setPerfil] = useState('');

  const { getPerfiles, deletePerfil, setPerfiles, newPerfil } = useApiConfigUsuarios();
  //const safePermissions = useMemo(() => permisos ?? {}, [permisos]);

  useEffect(() => {
    getPerfiles().then((res) => setData(res));
  }, []);

  const handleConfigureClick = useCallback(
    (e) => {
      const { data }: { data: Profile } = e.row;

      setIdPermiso(data.Pe_Prm_Id);
      setPerfil(data.Pe_Nombre);
      setIsModalVisible(true);
      //setPermisos(permisos); // Establecemos los permisos
    },
    []
  );

  const customData = useMemo(() => {
    const customStore = new CustomStore({
      key: 'Pe_Id',
      load: () =>
        getPerfiles()
          .then((res) => ({
            data: res,
            totalCount: res.length,
          }))
          .catch(() => {
            throw new Error('Error de carga de perfiles');
          }),
      insert: async (values) => {
        return newPerfil(values)
          .then((res) => {
            if (res === 105) {
              return getPerfiles().then((profiles) => {
                setData(profiles);
                return values;
              });
            }
            throw new Error('Error al insertar el perfil');
          })
          .catch((error) => {
            console.error(error);
            throw new Error('Error insertando el perfil');
          });
      },
      update: (key, values) => {
        return getPerfiles().then((profiles) => {
          const rowData = profiles.find((item) => item.Pe_Id === key);
          const updatedData = { ...rowData, ...values, Pe_Id: key };
          
          return setPerfiles(updatedData).then((res) => {
            if (res === 107) {
              return getPerfiles().then((profiles) => {
                setData(profiles);
                return values;
              });
            }
            throw new Error('Error al actualizar el perfil');
          });
        });
      },
      remove: (key) => {
        return deletePerfil({ IdPerfil: key }).then((res) => {
          if (res) {
            return getPerfiles().then((profiles) => {
              setData(profiles);
            });
          }
        });
      },
    });

    return new DataSource({
      store: customStore,
      reshapeOnPush: true,
    });
    // Remover las funciones de las dependencias para evitar recrear el store constantemente
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DataGrid className='grid custom-datagrid' height={'100%'} hoverStateEnabled={true} dataSource={customData} ref={dataGridRef} showColumnLines={true} rowAlternationEnabled={true} highlightChanges={true} repaintChangesOnly={true} width={'100%'}>
        <LoadPanel enabled={true} margin-bottom={10} />
        <SearchPanel visible placeholder='Buscar' />
        <Paging enabled={false} />
        <Editing mode='popup' allowUpdating={true} allowAdding={true} allowDeleting={true} />

        <Column caption='NOMBRE' dataField='Pe_Nombre' alignment='left'>
          <RequiredRule />
        </Column>
        <Column caption='DESCRIPCION' visible={false} dataField='Pe_Descripcion' alignment='left'>
          <RequiredRule />
        </Column>
        <Column caption='ESTADO' dataField='Pe_Estado' alignment='center' width={90}>
          <RequiredRule />
        </Column>

        <Column type='buttons' caption={'ACCIÓN'} width={120}>  
          <Butt name='edit' />
          <Butt name='delete' />
          <Butt hint='Configurar' icon='imgarlock' onClick={handleConfigureClick} />
        </Column>
      </DataGrid>

      <ModalPermissionsModal isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} perfil={perfil} idPermiso={idPermiso} />
    </>
  );
};

export default Index;
